import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  quote: string;
  author: string;
  location: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 px-4 ${className}`} data-id="element-281">
      <div className="max-w-6xl mx-auto" data-id="element-282">
        {title && <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-283">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-284">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-stone-200 flex flex-col h-full" data-id="element-285">
              <div className="flex gap-1 mb-4 text-amber-500" data-id="element-286">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-287" />)}
              </div>
              <p className="text-slate-700 text-lg mb-6 flex-grow italic" data-id="element-288">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-4 border-t border-stone-100" data-id="element-289">
                <p className="font-bold text-blue-900" data-id="element-290">{t.author}</p>
                <p className="text-sm text-slate-500" data-id="element-291">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}